import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getVentilatorSelector } from '../selectors'
import { saveVentilator } from '../store/ventilator.actions'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { comments } = ventilatorState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.ventilatorStateList && pcrDoc.patient?.ventilatorStateList.length) {
      const index = pcrDoc.patient?.ventilatorStateList?.findIndex(
        (ventilator) => ventilator.key === ventilatorState.key
      )
      if (index !== -1) {
        if (pcrDoc.patient.ventilatorStateList[index].comments !== comments) {
          yield put(saveVentilator())
        }
      }
    } else {
      yield put(saveVentilator())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([VentilatorConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
